module.exports = __webpack_public_path__ + "img/8.b5adb7e9.jpg";